"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnotationSwitcher = void 0;
const UiElements_1 = require("../../ui/UiElements");
class AnnotationSwitcher {
    constructor() {
        var _a;
        this.annotations = [];
        this.currentAnnotationIndex = -1;
        this.containerEl = null;
        this.prevBtnEl = this.createButton('arrow-left');
        this.nextBtnEl = this.createButton('arrow-right');
        this.annotationAddedSub = PubSub.subscribe("annotation-added" /* ANNOTATION_ADDED */, (_, annotation) => this.addAnnotation(annotation));
        this.annotationGotoSub = PubSub.subscribe("annotation-goto" /* ANNOTATION_GOTO */, (_, ann) => this.switchToAnnotation(ann));
        PubSub.subscribe("annotation-remove" /* ANNOTATION_REMOVE */, (_, annManualId) => this.removeAnnotation(annManualId));
        PubSub.subscribe("annotation-update" /* ANNOTATION_UPDATE */, (_, annotation) => this.updateAnnotation(annotation));
        PubSub.subscribe("toggle-annotation-switcher" /* TOGGLE_ANNOTATION_SWITCHER */, () => this.toggle());
        PubSub.subscribe("show-annotation-switcher" /* SHOW_ANNOTATION_SWITCHER */, () => this.show());
        PubSub.subscribe("hide-annotation-switcher" /* HIDE_ANNOTATION_SWITCHER */, () => this.hide());
        this.guiLayer = document.querySelector('.arc-viewer #guiLayer');
        if (!this.guiLayer) {
            return;
        }
        this.containerEl = this.createElement();
        (_a = this.guiLayer) === null || _a === void 0 ? void 0 : _a.appendChild(this.containerEl.domEl);
        this.addEvents();
    }
    updateAnnotation(changeData) {
        const annotation = this.annotations.find(ann => ann.manualId === changeData.manualId);
        if (!annotation) {
            return;
        }
        annotation.name = changeData.name;
        // Sort annotations to update order after order change
        this.annotations.sort(this.annotationComparison);
        this.switchToAnnotation(annotation);
    }
    toggle() {
        var _a;
        if ((_a = this.containerEl) === null || _a === void 0 ? void 0 : _a.domEl.classList.contains('active')) {
            this.hide();
            return;
        }
        this.show();
    }
    show() {
        var _a;
        (_a = this.containerEl) === null || _a === void 0 ? void 0 : _a.domEl.classList.add('active');
        PubSub.publish("annotation-hotspots" /* ANNOTATION_HOTSPOTS */, true);
        if (this.currentAnnotationIndex >= 0) {
            PubSub.publish("annotation-goto" /* ANNOTATION_GOTO */, this.annotations[this.currentAnnotationIndex]);
        }
    }
    hide() {
        var _a;
        (_a = this.containerEl) === null || _a === void 0 ? void 0 : _a.domEl.classList.remove('active');
        PubSub.publish("annotation-hotspots" /* ANNOTATION_HOTSPOTS */, false);
    }
    addAnnotation(annotation) {
        this.annotations.push(annotation);
    }
    removeAnnotation(manualId) {
        const annIndex = this.annotations.findIndex(a => a.manualId === manualId);
        if (annIndex === -1) {
            return;
        }
        this.annotations.splice(annIndex, 1);
        if (this.currentAnnotationIndex === annIndex) {
            this.prevAnnotation(false);
        }
    }
    addEvents() {
        this.prevBtnEl.domEl.onclick = () => this.prevAnnotation();
        this.nextBtnEl.domEl.onclick = () => this.nextAnnotation();
    }
    switchToAnnotation(annotation) {
        const annIndex = this.annotations.findIndex(ann => ann.manualId === annotation.manualId);
        if (annIndex === -1) {
            return;
        }
        this.currentAnnotationIndex = annIndex;
        this.refreshAnnotation(false);
    }
    prevAnnotation(emitEvent = true) {
        if (this.currentAnnotationIndex === 0 || this.currentAnnotationIndex === -1) {
            this.currentAnnotationIndex = this.annotations.length - 1;
        }
        else {
            this.currentAnnotationIndex -= 1;
        }
        this.refreshAnnotation(emitEvent);
    }
    nextAnnotation() {
        if (this.currentAnnotationIndex === this.annotations.length - 1) {
            this.currentAnnotationIndex = 0;
        }
        else {
            this.currentAnnotationIndex += 1;
        }
        this.refreshAnnotation();
    }
    refreshAnnotation(emitEvent = true) {
        var _a;
        const currAnn = this.annotations[this.currentAnnotationIndex];
        (_a = this.annotationNameEl) === null || _a === void 0 ? void 0 : _a.setTextContent((currAnn === null || currAnn === void 0 ? void 0 : currAnn.name) || '');
        if (emitEvent) {
            PubSub.publish("annotation-goto" /* ANNOTATION_GOTO */, currAnn);
        }
    }
    createElement() {
        this.annotationNameEl = this.createAnnoationNameDiv();
        return new UiElements_1.DivEl()
            .setId('annotationSwitcher')
            .addChild(this.prevBtnEl)
            .addChild(this.annotationNameEl)
            .addChild(this.nextBtnEl);
    }
    createAnnoationNameDiv() {
        return new UiElements_1.DivEl()
            .setId('annotationName')
            .setTextContent('Pick an annotation');
    }
    createButton(icon) {
        return new UiElements_1.ButtonEl().addChild(new UiElements_1.IconEl(icon));
    }
    annotationComparison(a, b) {
        if (a.orderNumber < b.orderNumber) {
            return -1;
        }
        else if (a.orderNumber > b.orderNumber) {
            return 1;
        }
        return 0;
    }
}
exports.AnnotationSwitcher = AnnotationSwitcher;
